export const HOME = '/';

export const SEARCH = HOME + 'search';
export const SEARCH_TYPE_BUY = '?type=buy';
export const SEARCH_TYPE_RENTAL = '?type=rental';

export const PROPERTY_PART = 'property'
export const PROPERTY = HOME + PROPERTY_PART;
export const PROPERTY_PAGE_OLD = `${HOME}object/:id`;
export const PROPERTY_PAGE = PROPERTY + '/:id';
export const CREATING_OBJECT = PROPERTY_PAGE + '/edit';

export const AGREEMENT = '/agreement/';
export const PRIVACY = '/privacy/';
export const AGREEMENT_CANCELLATION = '/agreement/cancellation';
export const CONTACTS = "/contacts";
export const HELP = "/help";
export const SERVICE = "/services";
export const RESERVATION_COMPLETE_PAGE = "/reservation";

export const AIRBNB = "/tech/airbnb"



// WEBPACK FOOTER //
// ./src/constants/RoutePaths.js